import * as React from "react";
import { useNavigate } from "react-router-dom";

import PageNotFound from "../../assets/svg/pageNotFound.svg";
import NewButton from "../../components/uiMerge/newButton";

import * as ROUTES from "../../constants/routes";


export const PageError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col justify-center items-center  py-6 px-[1rem]">
      <div className=" w-full flex flex-col justify-center gap-2 mt-[14rem] items-center">
        <div>
          <img src={PageNotFound} alt="" width={89} height={89} />
        </div>
        <div className="w-[257px]">
          <div>
            <h2 className="text-[24px] w-full text-center text-white font-bold mt-5 mb-1">
              Page not found
            </h2>
          </div>
          <div className="text-[#CECECF] font-[300] opacity-80 text-center text-[16px] mb-6">
            <p>We couldn't find what you're looking for.</p>
          </div>
        </div>

        <NewButton
        fullWidth
        variant="primary"
        onClick={() => navigate(ROUTES.LOGIN)}>
          Go to Homepage
        </NewButton>
      </div>
    </div>
  );
};
